import React, { Component } from "react"
import "./index.scss"
import DataChart from "./containers/DataChart"
import DataTable from "./containers/DataTable"
import Balance from './containers/Balance'
import { observer, Provider } from "mobx-react"
import Store from "app/stores/preview/dashboard"

@observer
export default class Index extends Component {
  constructor(props) {
    super(props)
    this.store = Store.fromJS()
  }

  render() {
    return (
      <Provider store={this.store}>
        <div className="preview">
          <Balance />
          <DataChart />
          <DataTable />
        </div>
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/preview/dashboard/index.js